"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ContactModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const Contact_contracts_1 = require("./Contact.contracts");
const ContactDataForm_1 = require("./form_partial/ContactDataForm");
const ContactLocationForm_1 = require("./form_partial/ContactLocationForm");
const ContactFormSettings_1 = require("./form_partial/ContactFormSettings");
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactModuleForm = ContactModuleForm_1 = class ContactModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = ContactModuleForm_1.getInitialContent();
    }
    /**
     * Function to check if header exist
     *
     * @return boolean
     */
    get hasHeader() {
        return this._content.header !== null;
    }
    /**
     * Function to set header according to hasHeader value
     */
    set hasHeader(value) {
        if (!value) {
            this._content.header = null;
            return;
        }
        this._content.header = {
            small: null,
            intro: {
                isBold: false,
                text: null
            },
            large: null
        };
    }
    /**
     * Accordion item's list
     */
    get tabsAsAccordionItem() {
        return [
            {
                component: ContactDataForm_1.ContactDataForm,
                id: 'contactData',
                label: this.$t('forms.contact.tabs.contactData.title'),
                props: {
                    content: this._content
                }
            },
            {
                component: ContactLocationForm_1.ContactLocationForm,
                id: 'location',
                label: this.$t('forms.contact.tabs.location.title'),
                props: {
                    content: this._content
                }
            },
            {
                component: ContactFormSettings_1.ContactFormSettings,
                id: 'contactForm',
                label: this.$t('forms.contact.tabs.contactForm.title'),
                props: {
                    content: this._content
                }
            }
        ];
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Contact,
            size: {
                colSpan: 6,
                isResizable: false,
                maxColSpan: 6,
                maxRowSpan: 6,
                minColSpan: 6,
                minRowSpan: 3,
                rowSpan: 3
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            background: null,
            header: null,
            tabs: {
                contactForm: {
                    id: Contact_contracts_1.ContactTabType.ContactForm,
                    canDisplay: false
                },
                contactData: {
                    id: Contact_contracts_1.ContactTabType.ContactData,
                    canDisplay: true,
                    content: [
                        {
                            title: '',
                            description: ''
                        }
                    ]
                },
                location: {
                    id: Contact_contracts_1.ContactTabType.Location,
                    canDisplay: true,
                    locationUrl: '<https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2443.5425524879147!2d21.017495015796776!3d52.2335282797609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471eccf6797d08b9%3A0xe09e0d1f1fd9ec2d!2sFoksal%2018%2C%2005-800%20Warszawa!5e0!3m2!1sen!2spl!4v1633606291549!5m2!1sen!2spl'
                }
            }
        };
    }
};
ContactModuleForm = ContactModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'ContactModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            DashmixAccordion: backoffice_1.DashmixAccordion,
            FormErrors: form_2.FormErrors,
            ModuleHeaderForm: form_2.ModuleHeaderForm
        },
        template: `
  <div>
    <!-- Header -->
    <DashmixCheck class="pb-2" :label="$t('forms.shared.hasHeader')" name="hasHeader"
                  :model.sync="hasHeader" />

    <ModuleHeaderForm v-if="hasHeader" :data.sync="_content.header" />
    <!-- Header| END -->

    <!-- Background -->
    <div class="form-group">
      <label for="background" class="d-block">{{ $t('forms.shared.background.label') }}</label>
      <DashmixInput type="color" :model.sync="_content.background" name="background"
                    :placeholder="$t('forms.shared.background.placeholder')" />
    </div>
    <!-- Background | END -->

    <div class="row">
      <div class="col">
        <h6>{{ $t('forms.contact.tabs.tabsTitle') }}</h6>
      </div>
    </div>

    <!-- Accordion -->
    <DashmixAccordion :items="tabsAsAccordionItem" />

    <!-- Form errors -->
    <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
  </div>`
    })
], ContactModuleForm);
exports.ContactModuleForm = ContactModuleForm;
//# sourceMappingURL=Contact.form.js.map